import { formatDate } from "./formatDate";
import { isDateToday } from "./isDateToday";

export const getDeliveredDate = (date: Date, timeZone: string | undefined) => {
  return isDateToday(date) ? `today` : formatDate(date, timeZone);
};
